<template>
    <div id="ContainerEmployeeTypesList">
        <h4 class="page-title text-truncate">
            {{ $t('employeeType.ApptByEmplTypeListTitle') }}
        </h4>
        <div class="row">
            <div class="col-12 mt-2">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="searchListing"
                        />
                        <div class="input-group-append">
                            <div class="input-group-append">
                                <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="searchListing"
                                >
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="false"
                            v-bind:showMessageIsEmpty="true"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="showApptTypesCheckBoxList"
                            v-bind:VisibleEditIcon="hasPermissionEdit()"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import EmployeeTypeService from '@/services/employeetypes.service';

import Permission from '@/common/Permission'

export default {
    name: 'AppointmnetByEmployeeTypesSetupList',
    mixins: [ShowMessage, DBFunctions,Permission],
    data() {
        return {
            selectedEmployeeCode: '',
            selectedEmployeeName: '',

            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },

            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0
            },
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            items: [],
            filterView: false,
            fields: [
                //{ key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-left' },
                { key: 'description', sortable: true, label: this.$t('employeeType.EmplTypeTitle'), class: 'text-rigth'},
                //{ key: 'systemType', sortable: true, label: this.$t('employeeType.InternalType'), class: 'text-rigth'}
            ],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },

    methods: {
        showApptTypesCheckBoxList (row) {
             this.$router.push({ name: "AppointmentByEmployeeTypesSetup-Details", params: { id: row.code}, query: {description: row.description} });    
        },

        searchListing() {
            this.currentPage = 1;
            this.SearchEmployeeType();
        },

        SearchEmployeeType() {
            this.$emit('load', true);
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.parameter.SearchCriteria = this.parameter.SearchCriteria.trim();

            EmployeeTypeService.getAllEmployeeType(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.totalRows = JSON.parse(headerString).TotalCount;
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
            this.SearchEmployeeType();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.SearchEmployeeType();
        },

    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.SearchEmployeeType();
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
};
</script>
